import {
  Component,
  OnInit,
  Input,
  ViewChild,
  ElementRef,
  AfterViewInit,
  EventEmitter,
  Output
} from '@angular/core';
import {Router} from '@angular/router';
import {
  CanvasActionConditionModel,
  CanvasRuleactionModel, PointModel
} from './canvastree.model';

import {Subject} from 'rxjs';

@Component({
  selector: 'app-canvas-form-builder',
  templateUrl: './canvas-form-builder.component.html',
  styleUrls: ['./canvas-form-builder.component.scss']
})
export class CanvasFormBuilderComponent implements OnInit, AfterViewInit {
  @ViewChild('canvas', {static: false}) canvas: ElementRef;
  @Input() canvasTree;
  @Input() chartMetaInfo: { scale: number; chartWidth: number; chartHeight: number; titleFont: any; titleColor: any; title: any; footerFont: any; footerColor: any; footerTitle: any; columnFont: any; columnTitleColor: any; leftaxisFont: any; leftaxisColor: any };
  //chartMetaInfo;
  private readonly numberInput$ = new Subject<number>();
  @Input()
  set theNumber(value: number) {
    this.numberInput$.next(value);
  }

  @Output() onSelected = new EventEmitter<any>();

  offsetY = 20;
  heigth = 50;

  public originalWidth = window.innerWidth;
  public originalHeight = window.innerHeight*2;

  private scale = 1;
  private rect: {left: number; right: number; top: number; buttom: number; width: number; height: number};

  constructor(public router: Router) {
    this.originalWidth = window.innerWidth / 2;
    this.originalHeight = window.innerHeight*2;
  }

  ngOnInit() {
    // debugger;
    this.scale = this.chartMetaInfo.scale ? this.chartMetaInfo.scale : 1;
    this.numberInput$.subscribe((data) => {
      const canvasEl: HTMLCanvasElement = this.canvas.nativeElement;
      const ctx = canvasEl.getContext('2d');
      ctx.canvas.width = 2200;//window.innerWidth * 1;
      ctx.canvas.height = window.innerHeight * 2  - 100;
      ctx.scale(this.scale, this.scale);
      this.drawActionLine(canvasEl, ctx, this.canvasTree, 25, this.chartMetaInfo.chartWidth);
    });
  }

  ngAfterViewInit() {
    const canvasEl: HTMLCanvasElement = this.canvas.nativeElement;
    const ctx = canvasEl.getContext('2d');
    ctx.scale(this.scale, this.scale);
    this.drawActionLine(canvasEl, ctx, this.canvasTree, 25, this.chartMetaInfo.chartWidth);
    canvasEl.addEventListener('click', (event) => {

      var rect = canvasEl.getBoundingClientRect();
      this.rect = {left: rect.left, right: rect.right, top: rect.top, buttom: rect.bottom, height: rect.height, width: rect.width};

      const x= (event.clientX - this.rect.left) / (this.rect.right - this.rect.left) * canvasEl.width;
      const  y= (event.clientY - this.rect.top) / (this.rect.buttom - this.rect.top) * canvasEl.height;
      const point: PointModel = {x: x/this.scale, y: y/this.scale};
      const ret = this.findSelectedBlock(point);
      this.onSelected.emit(ret);
      //ctx.isPointInPath()
    });

    canvasEl.addEventListener('mousemove', (event) => {
      // Handle the click event
      var rect = canvasEl.getBoundingClientRect();
      this.rect = {left: rect.left, right: rect.right, top: rect.top, buttom: rect.bottom, height: rect.height, width: rect.width};

      const x= (event.clientX - this.rect.left) / (this.rect.right - this.rect.left) * canvasEl.width;
      const  y= (event.clientY - this.rect.top) / (this.rect.buttom - this.rect.top) * canvasEl.height;
      const point: PointModel = {x: x/this.scale, y: y/this.scale};
      //ctx.fillText(x + ':' + y, x, y);
      const ret = this.findSelectedBlock(point);
      if (ret && ret.id > -1) {
    /*    debugger;*/
       // ctx.fillText(ret.name + '', ret.shape.offset.x,ret.shape.offset.y);
      }
      //this.onSelected.emit(ret);
      //ctx.isPointInPath()
    });
  }

  findSelectedBlock(event): {id: number; type: string; shape?: any; name?: string} {
    if (
      (this.canvasTree[0].shape.offset.x + 1*this.canvasTree[0].shape.r.x) > event.x &&
      (this.canvasTree[0].shape.offset.x - 1*this.canvasTree[0].shape.r.x) < event.x &&
      (this.canvasTree[0].shape.offset.y + 1*this.canvasTree[0].shape.r.y) > event.y &&
      (this.canvasTree[0].shape.offset.y - 1*this.canvasTree[0].shape.r.y) < event.y) {
      return {id: this.canvasTree[0].id, type: 'root', shape: null, name: 'USTAS'};
    }
    return this.findSelectedRule(this.canvasTree[0].rules, event);

  }

  findSelectedRule(rules: CanvasRuleactionModel[], event: any): { id: number; type: string; shape: any; name: string } {
    let ret = {id: -1, type: '', shape: null, name: ''};
    if (rules) {
      rules.filter(rule => !rule.invisible).forEach (rule => {
        if(ret.id > 0) {return ret;}
        if (rule.shape.type === 'line') {return;}
        const x0 = rule.shape.offset.x + rule.shape.w;
        const x1 = rule.shape.offset.x - 0*rule.shape.w;
        const y0 = 0 + (rule.shape.offset.y - 0*rule.shape.h);
        const y1 = 0 + (rule.shape.offset.y + rule.shape.h);
        if (
          x0 > event.x &&
          x1 < event.x &&
          y1 > event.y &&
          y0 < event.y) {
          ret =  {id: (rule.id as number), type: 'action', shape: rule.shape, name: rule.name + ''};
          return ret;
        }
        if (rule.conditions) {
          ret = this.findSelectedCondition(rule.conditions, event);
          return ret;
        }

      });
    }
    return ret;
  }
  findSelectedCondition(conditions: CanvasActionConditionModel[], event: any): {id: number; type: string; shape: any; name: string} {
    let ret = {id: -1, type: '', shape: null, name: ''};
    if (conditions) {
      conditions.forEach (cond => {
        if (ret.id > 0) {return ret;}
        if (cond.shape.type === 'line') {return;}
        const x0 = ((cond.shape as any).offset.x + 4*(cond.shape as any).r);
        const x1 = ((cond.shape as any).offset.x - 1*(cond.shape as any).r);
        const y0 = (200 + (cond.shape as any).offset.y + 2*(cond.shape as any).r);
        const y1 = (200 - (cond.shape as any).offset.y - 2*(cond.shape as any).r);
        if (
          ((cond.shape as any).offset.x + 1*(cond.shape as any).r) > event.x &&
          ((cond.shape as any).offset.x - 1*(cond.shape as any).r) < event.x &&
          ((cond.shape as any).offset.y + 1*(cond.shape as any).r) > event.y &&
          ((cond.shape as any).offset.y - 1*(cond.shape as any).r) < event.y) {
          ret = {id: (cond.id as number), type: 'condition', shape: cond.shape, name: cond.name + ''};
          return ret;
        }
        if (cond.rules) {
          ret =  this.findSelectedRule(cond.rules, event);
          return ret;
        }
      });
    }
    return ret;
  }

  plusModal(event) {
    this.scale *= 2;
    const canvasEl: HTMLCanvasElement = this.canvas.nativeElement;
    const ctx = canvasEl.getContext('2d');
    ctx.canvas.width = 2200*this.scale;//window.innerWidth * 1;
    ctx.canvas.height = window.innerHeight * 2 - 100;
    //context.globalCompositeOperation = 'destination-out';
    //context.fill(circle);
    ctx.scale(this.scale, this.scale);
    this.drawActionLine(canvasEl, ctx, this.canvasTree, 25, this.chartMetaInfo.chartWidth);

  }

  minusModal(event) {
    this.scale = this.scale / 2;
    const canvasEl: HTMLCanvasElement = this.canvas.nativeElement;
    const ctx = canvasEl.getContext('2d');
    ctx.canvas.width = 2200;//window.innerWidth * 1;
    ctx.canvas.height = window.innerHeight * 2;// - 500;
    //context.globalCompositeOperation = 'destination-out';
    //context.fill(circle);
    ctx.scale(this.scale, this.scale);
    this.drawActionLine(canvasEl, ctx, this.canvasTree, 25, this.chartMetaInfo.chartWidth);

  }

  applyAction() {

  }

  addTitleToChart(context){
    context.font = this.chartMetaInfo.titleFont;
    context.fillStyle = this.chartMetaInfo.titleColor;
    context.fillText(this.chartMetaInfo.title,100,30);
  }

  addFooterToChart(context) {
    context.font = this.chartMetaInfo.footerFont;
    context.fillStyle = this.chartMetaInfo.footerColor;
    context.fillText(this.chartMetaInfo.footerTitle,this.chartMetaInfo.chartWidth/2,this.chartMetaInfo.chartHeight-10);
  }

  addColumnName(context,name,xpos,ypos, color){
    context.font = this.chartMetaInfo.columnFont;
    context.fillStyle = color;//this.chartMetaInfo.columnTitleColor;
    context.fillText(name,xpos,ypos);
  }

  addHorizontalLines(context) {
    context.font = this.chartMetaInfo.leftaxisFont;
    context.fillStyle = this.chartMetaInfo.leftaxisColor;

    for(var i=0; i<11; i++) {

      context.lineWidth = 0.5;
      context.beginPath();
      context.moveTo(25,(20*i)+40);
      context.lineTo(475,(20*i)+40);
      context.strokeStyle  = this.chartMetaInfo.leftaxisColor;
      context.stroke();
    }
  }

  drawRect(context, block, list) {
    context.shadowOffsetX = 5;
    context.shadowOffsetY = 5;
    context.shadowBlur = 10;
    context.shadowColor = '#8e6e62';
    var gr = context.createRadialGradient(60,60,15,75,75,75);
    gr.addColorStop(0.0,'#0D6');
    gr.addColorStop(1.0,'#456');

    context.fillStyle = (gr);
    context.globalAlpha = list.shape?.opacity;

    block.rect(list.shape?.offset.x, list.shape?.offset.y, list.shape?.w, list.shape?.h);
    context.fill(block);
    //this.addColumnName(context, list[i].name, list[i].shape?.offset.x, list[i].shape?.offset.y);
    this.addColumnName(context, list.id + '', list.shape?.offset.x, list.shape?.offset.y, 'white');
  }

  drawLine(context, x0, y0, x1, y1, width, color?) {
    context.font = this.chartMetaInfo.leftaxisFont;
    context.fillStyle = color ? color : this.chartMetaInfo.leftaxisColor;
    context.shadowOffsetX = 0;
    context.shadowOffsetY = 0;
    context.shadowBlur = 0;
    context.shadowColor = '#8e6e62';

      context.lineWidth = width;
      context.beginPath();
      context.moveTo(x0,y0);
      context.lineTo(x1,y1);
      context.strokeStyle  = color ? color : this.chartMetaInfo.leftaxisColor;
      context.stroke();

  }

  addColumnHead(context,name,xpos,ypos){
    context.font = this.chartMetaInfo.columnFont;
    context.fillStyle = this.chartMetaInfo.columnTitleColor;
    context.fillText(name,xpos,ypos);
  }

  addColumnName2(context,name,xpos,ypos, color){
    context.font = this.chartMetaInfo.columnFont;
    context.fillStyle = color;//this.chartMetaInfo.columnTitleColor;
    context.fillText(name,xpos,ypos);
  }

  public drawTitle(ctx, list){
    const canvas = {width: 100, height: 100};
    /*ctx.shadowOffsetX = 0
    ctx.shadowOffsetY = 0
    ctx.shadowBlur = 10
    ctx.shadowColor = '#8e6e62';
    var gr = ctx.createRadialGradient(60,60,15,75,75,75);
    gr.addColorStop(0.0,'#0D6');
    gr.addColorStop(1.0,'#456');
    */ctx.shadowColor='rgba(0,0,0,0)';
    //ctx.fillStyle = (gr);
    if (list && list.shape.type === 'rect') {
/*      ctx.clearRect(list.shape.offset.x, list.shape.offset.y, list.shape.w, list.shape.h);
      ctx.save();
      ctx.beginPath();
      ctx.rect(list.shape.offset.x, list.shape.offset.y, list.shape.w, list.shape.h);
      ctx.closePath();
      ctx.clip();*/
      //ctx.drawImage(img,0,0);
      if(list.name){
        /*
              ctx.fillStyle = "#f30";
              ctx.fillRect(0,canvas.height-20,canvas.width,20);
        */
        ctx.fillStyle = 'gray';
        ctx.font='9pt Verdana';
        const textWidth=ctx.measureText(list.name).width;

        const n = Math.round(textWidth / list.shape.w);
        if (n <= 1) {
          ctx.fillText(list.name, list.shape.offset.x, list.shape.offset.y+30);
        } else {
          const N = list.name.length / (n + 1);
          for (let i = 0; i <= n; i++) {
            ctx.fillText(list.name.substr(i * N, (i+1)*N), list.shape.offset.x, list.shape.offset.y+ (11 * (i + 1)));
          }
        }

      }
    } if (list && list.shape.type === 'circle') {
      /*ctx.clearRect(list.shape.offset.x + list.shape.r, list.shape.offset.y, 100, 100);
      ctx.save();
      ctx.beginPath();
      ctx.rect(list.shape.offset.x + list.shape.r, list.shape.offset.y, 100, 100);
      ctx.closePath();
      ctx.clip();*/
      //ctx.drawImage(img,0,0);
      if(list.name){
        /*
              ctx.fillStyle = "#f30";
              ctx.fillRect(0,canvas.height-20,canvas.width,20);
        */
        ctx.fillStyle = 'green';
        ctx.font='12pt Verdana';
        const textWidth=ctx.measureText(list.name).width;

        const n = Math.round(textWidth / 100);
        if (n <= 1) {
          ctx.fillText(list.name, list.shape.offset.x + list.shape.r, list.shape.offset.y);
        } else {
          const N = list.name.length / (n + 1);
          for (let i = 0; i <= n; i++) {
            ctx.fillText(list.name.substr(i * N, (i+1)*N), list.shape.offset.x + list.shape.r, list.shape.offset.y+ (11 * (i + 1)));
          }
        }

      }
    }

    //ctx.restore();
  }

  drawActionLine(canvas, context, list, offsetx, width) {
    const canvasTree = this.canvasTree;
    const blocks: Path2D[] = new Array();
    let offsetX = offsetx;
    let delta = (width - (list.length + 1) * 25) / (list.length);
    delta = delta > 10 ? delta : 10;
    //debugger;
    const L = 2;//list.length + 1;
    for(let i =0; i < list.length; i++) {
      const id = list[i].id;
      const width = delta;//(this.canvasTree)[i].width;
      const height = this.heigth;
      let y = this.offsetY + this.heigth * list[i].level + this.offsetY*list[i].level;
      offsetX = offsetX  + (i > 0 ? (delta + 25) : 0);

      const x = offsetX;//25 * (i+1) + (this.canvasTree)[i].width * i;
      if (list[i].type === 'condition') {
            if (list[i].rules && list[i].rules.length > 0) {
              this.drawActionLine(canvas, context, list[i].rules, x, width);
            }
      } else if (list[i].type === 'rule') {
        if (list[i].conditions && list[i].conditions.length > 0) {
          this.drawActionLine(canvas, context, list[i].conditions,  x, width);
        }
      }
      blocks.push(new Path2D());
      //context.fillStyle = "#36b5d8";

      context.shadowOffsetX = 5;
      context.shadowOffsetY = 5;
      context.shadowBlur = 10;
      context.shadowColor = '#8e6e62';
      var gr = context.createRadialGradient(60,60,15,75,75,75);
      gr.addColorStop(0.0,'#0D6');
      gr.addColorStop(1.0,'#456');

      context.fillStyle = (gr);


      let defaultColor = '#456';
      let defaultColorPressed = '#8B0000';
      let _block = null;
      let _list = null;
      if (list[i].shape?.type === 'rect') {
        if (!list[i].invisible){
          this.drawRect(context, blocks[i], list[i]);
          _block = blocks[i];
          _list = list[i];
        }
        if (list[i].line) {
          this.drawLine(context, list[i].line.shape?.p0.x,
            list[i].line.shape?.p0.y, list[i].line.shape?.p1.x, list[i].line.shape?.p1.y,
            list[i].line.shape?.width ? list[i].line.shape?.width : 1.5,
            list[i].line.shape?.color ? list[i].line.shape?.color : this.chartMetaInfo.leftaxisColor);
        }

      } else if (list[i].shape?.type === 'ellipsis') {
        const deg = 0;
        const rad = deg * (Math.PI / 180.0);
        blocks[i].ellipse(list[i].shape?.offset.x, list[i].shape?.offset.y,
          list[i].shape?.r.x, list[i].shape?.r.y, 0, 0, 2 * Math.PI, true);
        context.stroke();
        let defaultColor = '#f7f41b';
        defaultColorPressed = '#a98307';
        context.fillStyle = defaultColor;
        context.fill(blocks[i]);
        //this.addColumnName(context, list[i].name, list[i].shape?.offset.x, list[i].shape?.offset.y);
        this.addColumnName(context, id, list[i].shape?.offset.x-10, list[i].shape?.offset.y-50, 'white');
        if (list[i].line) {
          this.drawLine(context, list[i].line.shape?.p0.x, list[i].line.shape?.p0.y, list[i].line.shape?.p1.x, list[i].line.shape?.p1.y, list[i].line.shape?.width ? list[i].line.shape?.width : 1.5);
        }
        _block = blocks[i];
        _list = list[i];
      } else if (list[i].shape?.type === 'circle') {
          blocks[i].arc(list[i].shape?.offset.x, list[i].shape?.offset.y, list[i].shape?.r, 0, 2 * Math.PI);
          let defaultColor = '#f7f41b';
          defaultColorPressed = '#a98307';
          context.fillStyle = defaultColor;
          context.fill(blocks[i]);
          //this.addColumnName(context, list[i].name, list[i].shape?.offset.x, list[i].shape?.offset.y);
          //this.addColumnName(context, id + ';' + x + ';' + y  + ';' + width  + ';' + height, x,y+20);
          this.addColumnName(context, id , list[i].shape?.offset.x-10, list[i].shape?.offset.y - 30, 'white');
        if (list[i].line) {
          this.drawLine(context, list[i].line.shape?.p0.x,
            list[i].line.shape?.p0.y, list[i].line.shape?.p1.x, list[i].line.shape?.p1.y,
            list[i].line.shape?.width ? list[i].line.shape?.width : 1.5,
            list[i].line.shape?.color ? list[i].line.shape?.color : this.chartMetaInfo.leftaxisColor);

        }
        _block = blocks[i];
        _list = list[i];
      } else if (list[i].shape?.type === 'line') {
        //this.addHorizontalLines(context);
        this.drawLine(context, list[i].shape?.p0.x, list[i].shape?.p0.y, list[i].shape?.p1.x, list[i].shape?.p1.y,
          list[i].shape?.width ? list[i].shape?.width : 1.5,
          list[i].shape?.color ? list[i].shape?.color : this.chartMetaInfo.leftaxisColor,
        );

      } else if (list[i].shape?.type === 'plus') {
        blocks[i].arc(list[i].shape?.offset.x, list[i].shape?.offset.y, list[i].shape?.r, 0, 2 * Math.PI);
        context.fillStyle = 'green';
        let defaultColor = 'green';
        defaultColorPressed = '004D26';
        context.fill(blocks[i]);
        context.font = '36px sans-serif';
        context.fillStyle = this.chartMetaInfo.columnTitleColor;
        context.fillText('+',list[i].shape?.offset.x - 10, list[i].shape?.offset.y + 10);
      } else if (list[i].type === 'rule') {
        this.drawRect(context, blocks[i], list[i]);
/*
        blocks[i].rect(x, y, width, height);
        context.fillStyle = 'red';
        context.fill(blocks[i]);
*/
        _block = blocks[i];
        _list = list[i];
        //this.addColumnName(context, id + ';' + x + ';' + y  + ';' + width  + ';' + height, x,y);
      } else if (list[i].type === 'condition') {
        blocks[i].arc(x, y + 20, 25, 0, 2 * Math.PI);
        context.fillStyle = 'yellow';
        context.fill(blocks[i]);
        //this.addColumnName(context, id + ';' + x + ';' + y  + ';' + width  + ';' + height, x,y+20);
        //this.addColumnName(context, list[i].name, x,y);
        this.addColumnName(context, id , list[i].shape?.offset.x, list[i].shape?.offset.y, 'black');
        _block = blocks[i];
        _list = list[i];
      }
      //this.addColumnHead(context, this.canvasTree[i].head, x,this.chartMetaInfo.chartHeight-10);
      var _this = this;
      if (_list !== null) {
        canvas.addEventListener('mousemove',function(event){

          if (false && context.isPointInPath(blocks[i], event.offsetX, event.offsetY)) {
            const pos = {x: _list.shape.offset.x, y: _list.shape.offset.y};
            _this.drawTitle(context, _list);
            //_this.drawText(context, pos, event.x);
            //context.fillText('USTAS' + '',list[i].shape?.offset.x,list[i].shape?.offset.y);
          }
        });
      }


      canvas.addEventListener('mousedown', function(event) {
        // Check whether point is inside circle
        //context.clearRect(0, 0, canvas.width, canvas.height);
        if (context.isPointInPath(blocks[i], event.offsetX, event.offsetY)) {

          context.fillStyle = defaultColorPressed;
          context.globalAlpha = list[i].shape?.opacity;
          context.fill(blocks[i]);
          context.font = '20px sans-serif';
          context.fillStyle = 'white';//this.chartMetaInfo.columnTitleColor;
          if (list[i].shape?.type === 'circle') {
            context.fillText(list[i].id + '',list[i].shape?.offset.x - 10,list[i].shape?.offset.y - 30);
          } else if (list[i].shape?.type === 'rect' && !list[i].invisible){
            context.fillText(list[i].id + '',list[i].shape?.offset.x,list[i].shape?.offset.y);
          }

          //context.font = '12px sans-serif';
          context.fillStyle = '#c1d0cd';

          context.lineWidth = 1.5;
          context.beginPath();
          context.moveTo(list[i].line.shape?.p0.x, list[i].line.shape?.p0.y);
          context.lineTo(list[i].line.shape?.p1.x, list[i].line.shape?.p1.y);
          context.strokeStyle  = '#c1d0cd';
          context.stroke();
          //this.addColumnName(context, id + '', list[i].shape?.offset.x, list[i].shape?.offset.y, 'white');
        } else if (list[i] && list[i].line && list[i].line.shape){

          context.fillStyle = defaultColor;
          context.globalAlpha = list[i].shape?.opacity;
          context.fill(blocks[i]);
          context.font = '20px sans-serif';
          context.fillStyle = 'white';//this.chartMetaInfo.columnTitleColor;
          if (list[i].shape?.type === 'circle') {
            context.fillText(list[i].id + '',list[i].shape?.offset.x - 10,list[i].shape?.offset.y - 30);
          } else if (list[i].shape?.type === 'rect' && !list[i].invisible){
            context.fillText(list[i].id + '',list[i].shape?.offset.x,list[i].shape?.offset.y);
          }

          //context.font = '12px sans-serif';
          context.fillStyle = '#c1d0cd';


          context.lineWidth = 1.5;
          context.beginPath();
          context.moveTo(list[i].line.shape?.p0.x, list[i].line.shape?.p0.y);
          context.lineTo(list[i].line.shape?.p1.x, list[i].line.shape?.p1.y);
          context.strokeStyle  = '#c1d0cd';
          context.stroke();
          //this.addColumnName(context, list[i].name, list[i].shape?.offset.x, list[i].shape?.offset.y);
          //this.addColumnName(context, id + '', list[i].shape?.offset.x, list[i].shape?.offset.y, 'white');
        }

      });

    }
  }


  protected readonly window = window;
}






